import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

// SSR trick to avoid re-configuring dayjs on the client
let configured = false;

export function setupDayjs() {
  if (configured) {
    return dayjs;
  }

  configured = true;
  dayjs.extend(localizedFormat);
  dayjs.extend(advancedFormat);
  dayjs.extend(customParseFormat);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(isSameOrBefore);
  dayjs.tz.setDefault(dayjs.tz.guess());

  return dayjs;
}

export default setupDayjs;
